/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Description1Inputs */

const he_notfound_description1 = /** @type {(inputs: Notfound_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ייתכן שהעמוד הוסר, שונה או שהכתובת שהזנת אינה נכונה.`)
};

const en_notfound_description1 = /** @type {(inputs: Notfound_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you're looking for doesn't exist or has been moved.`)
};

/**
* | output |
* | --- |
* | "The page you're looking for doesn't exist or has been moved." |
*
* @param {Notfound_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const notfound_description1 = /** @type {((inputs?: Notfound_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notfound_description1(inputs)
	return en_notfound_description1(inputs)
});
export { notfound_description1 as "notFound_description" }